import { setPatientSignatures } from "reducers/signatures";
import { API } from "actions/api";

// mintPapyrusOtt moved to actions/handoff.js — it sits alongside the portal
// handoff redemption rather than being duplicated per feature. See S3DEV2-7560.

export const fetchPatientSignatures = () => async dispatch => {
  try {
    const { signature_documents } = await dispatch({
      type: API,
      route: "patient_portal/mobile/signature_documents",
      method: "GET"
    });
    dispatch(setPatientSignatures(signature_documents));
    return signature_documents;
  } catch (error) {
    console.error(error.message);
  }
};
